<template>
    
    <v-app>
        <v-navigation-drawer
          v-model="drawer"
          app
          temporary
          left
          width="300"
          style="height: 100vh;"
        >
          <!-- Toolbar en modo vertical para drawer móvil -->
          <Toolbar :vertical="true" />
        </v-navigation-drawer>
    
    <v-app-bar app elevate-on-scroll color="white" height="70">
      <!-- Hamburguesa solo en móvil -->
      <v-app-bar-nav-icon class="d-lg-none" @click.stop="drawer = !drawer" color="primary" />
            
            <v-toolbar-title class="d-flex align-center">
                <router-link to="/" tag="span" style="cursor: pointer" class="d-flex align-center">
                    <v-img 
                        alt="Centro Médico Terrada" 
                        :src="require('@/assets/logoHeader.png')"
                        max-height="60"
                        max-width="220"
                        contain
                        class="mr-3"
                    />
                </router-link>
            </v-toolbar-title>            <v-spacer></v-spacer>
            
      <!-- Toolbar horizontal solo en desktop/tablet -->
      <div class="d-none d-md-flex">
        <v-toolbar-items>
          <Toolbar :vertical="false" />
        </v-toolbar-items>
      </div>
        </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
    
  <!-- Global confirmation/alert dialog -->
  <ConfirmDialog />
    <v-footer dark color="primary" class="pa-6">
      <v-container>
        <v-row>
          <!-- Logo y descripción -->
          <v-col cols="12" md="4" class="mb-4">
            <div class="d-flex align-center mb-3">
              <v-img 
                :src="require('@/assets/logoHeader.png')" 
                max-width="120" 
                class="mr-3"
              ></v-img>
              <div>
                <h3 class="white--text font-weight-bold">Centro Médico Terrada</h3>
                <p class="white--text mb-0">Tu salud es nuestra prioridad</p>
              </div>
            </div>
            <p class="white--text body-2">
              Brindamos atención médica de calidad con tecnología moderna y un equipo de profesionales comprometidos con tu bienestar.
            </p>
          </v-col>

          <!-- Enlaces rápidos -->
          <v-col cols="12" md="3" class="mb-4">
            <h4 class="white--text font-weight-bold mb-3">Enlaces Rápidos</h4>
            <div class="footer-links d-flex flex-column">
              <v-btn text color="white" class="justify-start pa-0 mb-1" :to="'/'">
                <v-icon left small>mdi-home</v-icon>
                Inicio
              </v-btn>
              <v-btn text color="white" class="justify-start pa-0 mb-1" :to="'/about'">
                <v-icon left small>mdi-information</v-icon>
                Nosotros
              </v-btn>
              <v-btn text color="white" class="justify-start pa-0 mb-1" :to="'/nuevoturno'">
                <v-icon left small>mdi-calendar-plus</v-icon>
                Solicitar Turno
              </v-btn>
              <v-btn text color="white" class="justify-start pa-0 mb-1" :to="'/login'">
                <v-icon left small>mdi-login</v-icon>
                Iniciar Sesión
              </v-btn>
            </div>
          </v-col>

          <!-- Información de contacto -->
          <v-col cols="12" md="3" class="mb-4">
            <h4 class="white--text font-weight-bold mb-3">Contacto</h4>
            <div class="white--text body-2">
              <div class="d-flex align-center mb-2">
                <v-icon color="white" class="mr-2" small>mdi-map-marker</v-icon>
                <span>{{ contactInfo.ADDRESS }}</span>
              </div>
              <div class="d-flex align-center mb-2">
                <v-icon color="white" class="mr-2" small>mdi-phone</v-icon>
                <span>{{ contactInfo.PHONE.DISPLAY }}</span>
              </div>
              <div class="d-flex align-center mb-2">
                <v-icon color="white" class="mr-2" small>mdi-email</v-icon>
                <span>{{ contactInfo.EMAIL }}</span>
              </div>
              <div class="d-flex align-center mb-2">
                <v-icon color="white" class="mr-2" small>mdi-clock</v-icon>
                <span>Lun - Vie: 12:00 - 20:00</span>
              </div>
            </div>
          </v-col>

          <!-- Redes sociales -->
          <v-col cols="12" md="2" class="mb-4">
            <h4 class="white--text font-weight-bold mb-3">Síguenos</h4>
            <div class="footer-social d-flex flex-column">
              <v-btn icon color="white" class="mb-2" href="#" target="_blank">
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
              <v-btn icon color="white" class="mb-2" :href="contactInfo.WHATSAPP.LINK" target="_blank">
                <v-icon>mdi-whatsapp</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-4" color="rgba(255,255,255,0.3)"></v-divider>

        <!-- Copyright y créditos -->
        <v-row align="center">
          <v-col cols="12" md="8">
            <p class="white--text body-2 mb-0">
              © {{ new Date().getFullYear() }} Centro Médico Terrada. Todos los derechos reservados.
            </p>
          </v-col>
          <v-col cols="12" md="4" class="text-md-right">
            <p class="white--text body-2 mb-0">
              Desarrollado por 
              <a href="mailto:innovaticsoluciones@gmail.com" class="white--text text-decoration-none">
                <strong>Innovative Solutions</strong>
              </a>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <!-- Snackbar global para mensajes -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    
    </v-app>

</template>

<script>

import Toolbar from './components/Toolbar.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'
import { config } from '@/config'

    export default {
        name: 'App',
        components:{
            Toolbar,
            ConfirmDialog
        },
        watch: {
            group () {
            this.drawer = false
            },
        },
        data(){
            return{
                sidebar: false,
                drawer: false,
                group: null
            }
        },
        computed: {
            snackbar() {
                return this.$store.state.snackbar;
            },
            contactInfo() {
                return config.CONTACT;
            }
        },
        mounted() {
            if(this.$store.state.authenticated) {
                if (this.$route.name !== 'calendar' && this.$route.name !== 'turno') {
                    this.$router.replace({ name: "calendar" }).catch(err => {
                        // Ignore the NavigationDuplicated error
                        if (err.name !== 'NavigationDuplicated') {
                            throw err;
                        }
                    });
                }
            }
        }
        
    }
</script>

<style>
#app .v-toolbar__content .v-toolbar__title {
  display: flex;
  align-items: center;
}

.v-app-bar {
  background-color: #ffffff !important;
}

.toolbar{
    margin-top: 5pm;
}

#app {
  margin-top: 10px;
  color: #64323b;
}

/* Evitar overflow horizontal en móviles */
html, body, #app, .v-application {
  overflow-x: hidden;
}


/* Limpieza de estilos antiguos del nav que forzaban layout horizontal */
#nav ul li { display: initial; margin: initial; }
#nav ul li:last-child { margin: initial; }
#nav a { all: unset; }
#nav a.router-link-exact-active { color: inherit; }

.ghbutton:active {
border-color: #ffffff;
}

.ghbuttondark {
    border: none;
    color: white;
    border-radius: 20px;
    background: #8D4E3C;
    border: 1px solid #8D4E3C;
    text-transform: uppercase;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
}

.ghbuttondark:hover, .ghbuttondark:focus {

    background: #8D4E3C;
    border-color: #8D4E3C;
 
}


.ghbuttondark:active {

    background: #6D4C41;
    border-color: #ffffff;
 
}

.footer {
    border-top: 1px solid #bedfe4;
}

.greybutton {
    background: #90A4AE;
    color: #ffffff;
    border-color: #90A4AE;
}

.greybutton:hover, .greybutton:focus   {
    background: #78909C;
    border-color: #78909C;
}


.greybutton:active   {
    background: #607D8B;
    border-color: #ffffff;
}

table tr:nth-child(even) {
    background: #ffffff;
    }
table tr:nth-child(odd) {
    background: #F5F5F5;
    }
.ghtopbar {
    background-color: #EFEBE9;
    padding: 10px;
    padding-bottom:0px;
    border-radius: 4px;
    margin-bottom: 3rem;
}

div.ghtopbar button.ghbutton {

    margin-right: 12px;
    margin-left: 12px;
    height: 30px;
    line-height: 20px;
    background-color: #F5F5F5;
    border-color: #F5F5F5;
    font-size: 15px;
    color: #8D4E3C;
    letter-spacing: 0px;
    font-weight: bold;
}

div.ghtopbar button.ghbutton:active {

    border-color: #cfdee0;

}

div.ghtopbar button.ghbutton::after {
    content: '|';
    position: relative; 
    top: 0px;
    right: -45px;
    font-size: 20px;
    font-weight: bold;
    color: #64323b;
}
div.ghtopbar button.ghbutton:last-child::after {
     content: none;
  
}

.red {
color: red;
font-weight: bold;
}

@media screen and (max-width: 500px){
    #nav ul li{
        float: center
  }
}


.v-toolbar__title {
    margin: 0 0 0 0;
}

.u-max-full-width mb-3{
    margin: 0 0 0 0;
}
.u-max-full-width {
  max-width: 100%;
  box-sizing: border-box; 
}

/* Estilos modernos para el header */
.v-app-bar {
  box-shadow: 0 2px 10px rgba(0,0,0,0.1) !important;
}

.v-toolbar__title .text-h6 {
  line-height: 1.2;
}

.v-toolbar__title .text-subtitle-1 {
  line-height: 1;
  margin-top: -2px;
}

/* Estilos para botones del toolbar */
.v-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  font-weight: 500;
}

.v-btn.v-btn--outlined {
  border-width: 2px !important;
}

/* Mejoras responsive */
@media (max-width: 960px) {
  .v-toolbar__title .text-h6 {
    font-size: 1rem !important;
  }
  
  .v-toolbar__title .text-subtitle-1 {
    font-size: 0.8rem !important;
  }
}

/* Estilos para el footer moderno */
.v-footer {
  background: linear-gradient(135deg, #8D4E3C 0%, #6D4C41 100%) !important;
}

.v-footer .v-btn {
  text-transform: none !important;
  border-radius: 6px !important;
}

.v-footer .v-btn--text {
  min-width: auto !important;
  padding: 4px 8px !important;
}

.v-footer .v-btn--icon {
  background-color: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.v-footer .v-btn--icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.v-footer h3,
.v-footer h4 {
  font-family: 'Roboto', sans-serif;
}

.v-footer .text-decoration-none:hover {
  text-decoration: underline !important;
}

/* Responsive para footer */
@media (max-width: 960px) {
  .v-footer .text-md-right {
    text-align: center !important;
  }

  /* Mantener enlaces rápidos en columna en móvil */
  .v-footer .footer-links {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  /* Solo las redes sociales se ordenan en fila en móvil */
  .v-footer .footer-social {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    justify-content: center;
  }
}

/* Enlaces rápidos: ocupar ancho completo y no desbordar */
.v-footer .footer-links .v-btn {
  width: 100% !important;
  max-width: 100% !important;
  justify-content: flex-start !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Íconos sociales consistentes y sin overflow */
.v-footer .footer-social .v-btn.v-btn--icon {
  width: 40px;
  height: 40px;
  margin: 0 8px 8px 0;
}

/* Evitar desbordes por textos largos (emails, etc.) */
.v-footer .body-2 {
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* Asegurar que el drawer temporal se muestre por encima del app-bar */
.v-navigation-drawer--temporary { z-index: 3000 !important; }
.v-app-bar { z-index: 2000 !important; }
</style>